<section class="main-content">
    <div class="header">
        <h2>Nuevo rol</h2>
        <button (click)="closeModal()" mat-icon-button>
            <mat-icon>close</mat-icon>
        </button>
    </div>
    <form [formGroup]="registerRole" (ngSubmit)="submitRegisterRole()">
        <section class="form-content">
            <mat-form-field>
                <mat-label>Nombre</mat-label>
                <input formControlName="name" matInput />
            </mat-form-field>
            <mat-form-field>
                <mat-label>Código</mat-label>
                <input formControlName="code" matInput />
            </mat-form-field>
            <mat-form-field>
                <mat-label>Descripción</mat-label>
                <input formControlName="description" matInput />
            </mat-form-field>
            <mat-form-field>
                <mat-label>Permisos</mat-label>
                <mat-select formControlName="permissions" multiple>
                    <mat-option *ngFor="let permission of permissions$ | async"
                    [value]="permission.permissionId">
                        {{ permission.description}}
                    </mat-option>
                </mat-select>
            </mat-form-field>
        </section>
        <section class="form-content-footer">
            <button type="submit" [disabled]="registerRole.invalid" class="w-25" mat-flat-button color="primary">
                Agregar
            </button>
        </section>
    </form>
</section>